import * as React from 'react'
import { useMemo } from 'react'
import { ContributionType } from '../../../../../generated/graphql'
import { useTheme } from '../../../../../hooks/theme.hook'
import { SegmentedButtons } from 'react-native-paper'
import {
  Icon3dChallenge,
  Icon3dEdit,
  Icon3dInquiry,
} from '../../../../../utils/meldd-icons'
import { useNavigation } from '@react-navigation/native'
import { AppNavigation } from '../../../navigation/types'
import { Icon } from '../../../../../@ui/icon'
import { useIsMobileDevice } from '../../../../../hooks/is-mobile.hook'

interface ContributionCountProps {
  perspectiveId: string
  visible?: boolean
  contributions: { contributionType: ContributionType }[]
  handleClick: (type: ContributionType) => void
}

export function ContributionCount(props: ContributionCountProps) {
  const theme = useTheme()
  const isMobile = useIsMobileDevice()
  const inquiryCount = useMemo(
    () =>
      props.contributions.filter(
        (c) => c.contributionType === ContributionType.Inquiry
      ).length,
    [props.contributions]
  )
  const challengeCount = useMemo(
    () =>
      props.contributions.filter(
        (c) => c.contributionType === ContributionType.Challenge
      ).length,
    [props.contributions]
  )
  const editCount = useMemo(
    () =>
      props.contributions.filter(
        (c) => c.contributionType === ContributionType.Edit
      ).length,
    [props.contributions]
  )

  const responsiveStyle = useMemo(
    () => ({
      fontSize: isMobile ? 14 : 13,
      iconSize: isMobile ? 14 : 16,
      segmentWidth: isMobile ? 60 : undefined, // 60 is the smaller can do to see the text
    }),
    [isMobile]
  )
  return (
    <SegmentedButtons
      onValueChange={props.handleClick}
      value={''}
      density={isMobile ? 'small' : 'regular'}
      style={{
        paddingHorizontal: 1,
      }}
      theme={{
        fonts: {
          labelLarge: {
            fontSize: responsiveStyle.fontSize,
            textDecorationLine: 'underline',
          },
        },
      }}
      buttons={[
        {
          value: ContributionType.Inquiry,
          label: '' + inquiryCount,
          icon: () => (
            <Icon3dInquiry
              size={responsiveStyle.iconSize}
              mode="text"
              onPress={() => props.handleClick(ContributionType.Inquiry)}
            />
          ),
          style: {
            minWidth: responsiveStyle.segmentWidth,
            width: responsiveStyle.segmentWidth,
          },
          uncheckedColor: theme.colors.primary,
        },
        {
          value: ContributionType.Challenge,
          label: '' + challengeCount,
          icon: () => (
            <Icon3dChallenge
              size={responsiveStyle.iconSize}
              mode="text"
              onPress={() => props.handleClick(ContributionType.Challenge)}
            />
          ),
          style: {
            minWidth: responsiveStyle.segmentWidth,
            width: responsiveStyle.segmentWidth,
          },
          uncheckedColor: theme.colors.primary,
        },
        {
          value: ContributionType.Edit,
          label: '' + editCount,
          icon: () => (
            <Icon3dEdit
              size={responsiveStyle.iconSize}
              mode="text"
              onPress={() => props.handleClick(ContributionType.Edit)}
            />
          ),
          style: {
            minWidth: responsiveStyle.segmentWidth,
            width: responsiveStyle.segmentWidth,
          },
          uncheckedColor: theme.colors.primary,
        },
      ]}
    />
  )
}
